module.exports = __webpack_public_path__ + "img/usecase_enterprise_02.39b8a838.jpg";